/*global module:false */
"use strict";

var $ = window.$;

module.exports = (function(){
    var getWindowScrollTop = function(){
        return $(window).scrollTop();
    };
    var getWindowHeight = function(){
        return $(window).outerHeight();
    };
    var getDocumentHeight = function(){
        return $(document).outerHeight();
    };
    var getNavHeight = function(){
        return $('#header-nav').outerHeight();
    };
    var getTopNavHeight = function(){
        return $('#top-nav').outerHeight();
    };
    var getContentHeight = function(){
        return $('#content').outerHeight();
    };
    return {
        getWindowScrollTop: getWindowScrollTop,
        getWindowHeight: getWindowHeight,
        getDocumentHeight: getDocumentHeight,
        getNavHeight: getNavHeight,
        getTopNavHeight: getTopNavHeight,
        getContentHeight: getContentHeight
    };
})();